import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";

export default function VorteileLandingpage({className}) {
  const [selected, setSelected] = useState("verkäufer");

  function handleClick(e) {
    setSelected(e.target.id);
  }

  const variants = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };

  // Restructure details array as an array of objects with id, title, and src
  const details = [
    { id: "verkäufer", 
        details:[{
          src: "/Icons/landingpage-vorteile-verkäufer-1.svg",
          title: "Sorgloser Verkauf", 
          description:"Seit 1978 begleiten wir Immobilienverkäufe - zuverlässig, strukturiert und vorausschauend."
     },
     {
        src: "/Icons/landingpage-vorteile-verkäufer-2.svg",
        title: "Optimaler Verkaufspreis",
        description:"Wir kennen den Markt, erkennen den Wert und setzen den optimalen Verkaufspreis für Sie durch."
   },
   {
    src: "/Icons/landingpage-vorteile-verkäufer-3.svg",
    title: "Persönliche Begleitung",
    description:"Immobilien sind Vertrauenssache. Deshalb hören wir zu, denken mit und nehmen uns Zeit für Sie."
},

     
     ]
      },
    { id: "käufer", 
      details:[{
        src: "/Icons/landingpage-vorteile-käufer-1.svg",
        title: "Persönliche Beratung",
        description:"Beim Immobilienkauf zählt nicht nur der Grundriss – sondern jemand der zuhört und versteht."
      },
      {
        src: "/Icons/landingpage-vorteile-käufer-2.svg",
        title: "Passende Finanzierungen",
        description:"Finden Sie die passende Lösung dank eines starken Finanzierungspartners mit Zugriff auf über 500 Banken."
   },
   {
    src: "/Icons/landingpage-vorteile-käufer-3.svg",
    title: "Sichere Abwicklung",
    description:"Vom ersten Termin bis zur Schlüsselübergabe: Wir sorgen dafür, dass alles richtig läuft."
},]
    },
  ];

  return (
    <div>
      <div className={cn("max-w-[85rem] mx-auto flex flex-col md:justify-center items-center font-sans", className)}>
        <div className="py-5 text-center">
          <h2 className="font-serif text-2xl md:text-3xl text-prime-950 font-bold">Ihre Vorteile</h2>
          <p className="text-xl pt-2 text-gray-600"></p>
        </div>
        <div className="flex items-center p-[0.3rem] rounded-lg justify-center border border-prime-950/10 bg-white">
          <button
            type="button"
            id="verkäufer"
            onClick={handleClick}
            className={`${
              selected === "verkäufer"
                ? "bg-prime-900 text-white "
                : "bg-white text-prime-900"
            } px-4 w-[7rem] py-1 rounded-md `}
          >
            Verkäufer
            <span></span>
          </button>
          <button
            type="button"
            id="käufer"
            onClick={handleClick}
            className={`${
              selected === "käufer"
                ? "bg-prime-900  text-white"
                : "bg-white text-prime-900"
            } px-4 w-[7rem] py-1 rounded-md `}
          >
            Käufer
          </button>
        </div>
          {details.map((detail, index) =>
            selected === detail.id ? (
              <motion.div
                key={detail.id}
                className="flex md:flex-row flex-col w-full items-center justify-evenly text-center py-10 gap-5"
              >
                {details[index].details.map((item, index) => (
                                <Reveal  delay={0.2 + index * 0.1}   key={item.id}
>

                  <motion.div
                    className=" flex flex-col items-center py-3 justify-center overflow-hidden"
                  >
                    <img
                      src={item.src}
                      alt={item.title}
                      className="size-16 mb-4 "
                    />
                    <div className="p-4 md:h-[10rem]  max-w-[25rem]">
                      <h3 className="text-xl font-serif pb-2 font-semibold text-prime-900">
                        {item.title}
                      </h3>
                      <p className="text-gray-600">
                       {item.description}
                      </p>
                    </div>
                  </motion.div>
                  </Reveal>

                ))}
                
              </motion.div>
            ) : null
          )}
        <div>
          <Link to="/verkaufen">
            <p className="font-serif text-prime-950  underline-offset-4 underline hover:text-prime-700 text-lg font-medium py-5">
mehr erfahren            </p>
          </Link>
        </div>
      </div>
    </div>
  );
}
